import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PermissionsGuard, PermissionsGuardData} from 'app/guards/permissions.guard';
import {CleanApiCacheGuard} from 'app/shared/modules/api/guards/clean-api-cache-guard.service';
import {SharedModule} from 'app/shared/shared.module';
import {SdInternalDashboardPageComponent} from './components/sd-internal-dashboard-page/sd-internal-dashboard-page.component';
import {AnalyticsSharedModule} from 'app/features/analytics/shared/analytics-shared.module';

const routes: Routes = [
    {
        path: '',
        component: SdInternalDashboardPageComponent,
        data: <PermissionsGuardData>{permission: 'canViewInternalDashboard', redirectToHome: true},
        canActivate: [PermissionsGuard],
        canDeactivate: [CleanApiCacheGuard],
    },
];

@NgModule({
    imports: [CommonModule, SharedModule, AnalyticsSharedModule, RouterModule.forChild(routes)],
    declarations: [SdInternalDashboardPageComponent],
    providers: [],
})
export class InternalDashboardModule {}
